{
  "required": "Erforderlich",
  "must_be_less_than": "Muss aus {{ characters }} Zeichen oder weniger bestehen",
  "problem_with_our_servers": "Es gab ein Problem mit unseren Servern. Bitte versuchen Sie es später erneut.",
  "problem_with_our_servers_code": "Es gab ein Problem mit unseren Servern. Der Fehlercode lautet {{ code }}",
  "problem_with_data_submitted": "Es gab ein Problem mit den Daten, die an den Server gesendet wurden",
  "connecting_with_our_servers": "Bei der Verbindung zu unseren Servern ist ein Problem aufgetreten. Bitte versuchen Sie es später erneut.",
  "timeout_connecting_servers": "Bei Ihrer Anfrage wurde das Zeitlimit überschritten. Bitte versuchen Sie es erneut.",
  "internet_connection_issue": "Es gibt ein Problem mit der Verbindung zum Server. Bitte überprüfen Sie Ihre Internetverbindung",
  "copy_code": "Code kopieren",
  "polygon_edit_error": "Polygone müssen mindestens 3 Knoten haben",
  "linestring_edit_error": "Linien müssen mindestens 2 Knoten haben",
  "unknown_edit_error": "Ein unbekannter Fehler ist aufgetreten",
  "billing_error": "Es gab ein Problem mit der Abrechnung für Ihr Projekt",
  "service_unavailable": "Dieser Service ist derzeit nicht verfügbar. Bitte wenden Sie sich an einen Projektadministrator",
  "three_nested": "Sie können keinen Ordner mit einer Tiefe von mehr als 3 Ebenen erstellen",
  "error": "Fehler",
  "invalidLink": "Ungültiger Link",
  "error_boundaries": {
    "title_large": "Hoppla! Irgendwas ist schief gelaufen.",
    "title_small": "Etwas ist schief gelaufen!",
    "error_message": "Etwas ist schief gelaufen und unser Team wurde alarmiert. Wenn das Problem weiterhin besteht, wenden Sie sich an den Support unter ",
    "error_code": "Fehlercode: {{ code }}",
    "contact": "Kontaktiere uns",
    "refresh": "Auffrischen",
    "reload": "Neu laden",
    "webgl_error_title": "WebGL-Fehler erkannt",
    "webgl_error_message": "Ihr Browser oder Gerät unterstützt WebGL nicht, das für die Anzeige dieses Plans erforderlich ist.",
    "webgl_support_message": "Eine Anleitung zur Aktivierung von WebGL finden Sie möglicherweise hier: ",
    "webgl_error_contact": "Wenn das Problem weiterhin besteht, wenden Sie sich an den Support unter ",
    "version_error_title": "Eine neue Version von Iventis ist verfügbar",
    "version_error_message": "Bitte aktualisieren Sie Ihren Browser, um die neueste Version von Iventis zu laden.",
    "connection_error_title": "Fehler bei der Verbindung",
    "connection_error_message": "Es gab ein Problem mit Ihrer Verbindung. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut."
  },
  "digital_twin": {
    "capacity": "Ungenügende Serverkapazität für den digitalen Zwilling. Bitte versuchen Sie es später erneut oder kontaktieren Sie {{ supportEmail }} für weitere Informationen",
    "occupied": "Der digitale Zwilling ist derzeit besetzt. Bitte versuchen Sie es später erneut.",
    "afk": "Sie wurden aufgrund von Inaktivität vom digitalen Zwilling getrennt.",
    "connection_failed": "Es konnte keine Verbindung zum digitalen Zwillingsdienst hergestellt werden. Bitte versuchen Sie es später erneut.",
    "generic": "Es gab ein Problem mit dem digitalen Zwillingsdienst. Bitte versuchen Sie es später erneut."
  },
  "custom_network_error": {
    "create": {
      "title": "{{ entity }} konnte nicht erstellt werden",
      "message": "Das Erstellen von {{ entity }} wurde nicht gespeichert"
    },
    "update": {
      "title": "{{ entity }} konnte nicht aktualisiert werden",
      "message": "Ihre Änderungen an der {{ entity }} wurden nicht gespeichert"
    },
    "import_error": {
      "title": "{{ entity }} konnte nicht importiert werden",
      "message": "Ihre {{ entity }} wurden nicht importiert"
    },
    "export_error": {
      "title": "{{ entity }} konnte nicht exportiert werden",
      "message": "Ihre {{ entity }} wurden nicht exportiert"
    },
    "delete_error": {
      "title": "{{ entity }} konnte nicht gelöscht werden",
      "message": "Ihre {{ entity }} wurde nicht gelöscht"
    },
    "generic": {
      "title": "{{ action }} konnte nicht ausgeführt werden",
      "message": "Ihre Anfrage an {{ action }} war nicht erfolgreich"
    }
  }
}